// extracted by mini-css-extract-plugin
module.exports = {"multiple":"StatusFilters_multiple__34nth"};